import { GearIcon } from '@radix-ui/react-icons'
import { BottomOverlayMenuButton, useSiteViewContext } from 'features/siteView'
import React, { FC, MouseEvent } from 'react'
import styled from 'styled-components'
import { Vector2 } from 'three'

const StyledGearIcon = styled(GearIcon)`
  width: 32px;
  height: 32px;
  padding: 3px;
  margin-left: -4px;
`

interface EditSiteConfigButtonProps {
  closeMenu: () => void
}

export const EditSiteConfigButton: FC<EditSiteConfigButtonProps> = (props) => {
  const { setShowEditSiteConfigPopupMenu } = useSiteViewContext()

  return (
    <BottomOverlayMenuButton
      onClick={(e: MouseEvent) => {
        setShowEditSiteConfigPopupMenu(new Vector2(e.clientX, e.clientY))
        props.closeMenu()
      }}>
      <StyledGearIcon />
      <span>Edit Site Config</span>
    </BottomOverlayMenuButton>
  )
}
